export default {
  path: '/shop-info',
  name: 'shop-info',
  component: () => import('@/modules/shop-info/pages/ShopInfo.vue'),
  meta: {
    metaTags: [
      {
        name: 'description',
        content: 'View important statistics about any Etsy shop, see where it ranks, and gain insight into its success.',
      },
      {
        name: "google",
        content: "notranslate",
      },
      {
        page_slug: 'shop-info',
      },
    ],
    title: 'eRank — Shop Info',
    requiresAuth: true,
  },
  children: [
    {
      path: ':shopName',
      children: [
        {
          path: '',
          name: 'shop-overview',
          component: () => import('@/modules/shop-info/pages/Overview.vue'),
          meta: {
            requiresAuth: false,
          },
        },
        {
          path: 'listings',
          name: 'shop-listings',
          component: () => import('@/modules/shop-info/pages/Listings.vue'),
          meta: {
            requiresAuth: true,
          },
        },
        {
          path: 'tags',
          name: 'shop-tags',
          component: () => import('@/modules/shop-info/pages/TopTags.vue'),
          meta: {
            requiresAuth: true,
          },
        },
      ],
    },
  ],
};
